<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter">LIST OF CHARACTERS</h1>
<p class="nonindent"><strong>Sharon Nagy</strong>. A cosmologist and longtime domestic partner of Tom</p>
<p class="nonindent"><strong>Tom Schwoerin</strong>. A cliologist (mathematical historian) and longtime domestic partner of Sharon</p>
<p class="nonindent"><strong>Judy Cao</strong>. A librarian, later Tom’s research assistant</p>
<p class="nonindent"><strong>Jackson Welles</strong>. Sharon’s chairman</p>
<p class="nonindent"><strong>Hernando Kelly</strong>. Post-doc in nucleonic engineering; shares an office with Sharon</p>
<p class="nonindent"><strong>Anton Zaengle</strong>. An historian at the Albert-Louis University in Freiburg and colleague of Tom</p>
<p class="nonindent"><strong>Monsignor Heinrich Lurm</strong>. An official of the Diocese of Freiburg and an amateur archeologist</p>
<p class="nonindent"><strong>Gus Mauer and Sepp Fischer</strong>. Workmen from Freiburg</p>
<p class="center">GEMEINDE OBERHOCHWALD</p>
<p class="nonindent"><strong>Pastor Dietrich</strong>. The <em>doctor seclusus</em>. Onetime student of Jean Buridan de Bethune, now pastor of St. Catherine’s Church in Oberhochwald</p>
<p class="nonindent"><strong>Brother Joachim von Herbholzheim</strong>. A Spiritual Franciscan waiting out a quarrel in the Strassburg friary</p>
<p class="nonindent"><strong>Theresia Gresch</strong>. Herb woman and healer; Dietrich’s onetime ward</p>
<p class="nonindent"><strong>Gregor Mauer</strong>. Stone mason in Oberhochwald</p>
<p class="nonindent"><strong>Lorenz and Wanda Schmidt</strong>. Blacksmith in Oberhochwald and his wife</p>
<p class="nonindent"><strong>Klaus Müller</strong>. <em>Maier</em> of the village. Operates the Herr’s mill</p>
<p class="nonindent"><strong>Hildegarde Müller</strong>. The miller’s wife</p>
<p class="nonindent"><strong>Volkmar Bauer</strong>. A strong farmer holding several manses</p>
<p class="nonindent"><strong>Seppl Bauer</strong>. Bauer’s son; betrothed to Ulrike Ackermann</p>
<p class="nonindent"><strong>Felix and Ilse Ackermann</strong>. A farmer in Oberhochwald and his wife</p>
<p class="nonindent"><strong>Maria Ackermann</strong>. Ackermann’s younger daughter</p>
<p class="nonindent"><strong>Ulrike Ackermann</strong>. Ackermann’s older daughter; betrothed to Seppl Bauer</p>
<p class="nonindent"><strong>Heinrich Altenbach</strong>. A homesteader near Oberhochwald</p>
<p class="nonindent"><strong>Herwyg One-eye</strong>. Farms Dietrich’s tithe lands</p>
<p class="nonindent"><strong>Trude Metzger</strong>. Widow. Holds the strips abutting Herwyg. Her sons are Melchior and Peter</p>
<p class="nonindent"><strong>Nickel Langermann</strong>. A gärtner</p>
<p class="nonindent"><strong>Walpurga Honig</strong>. Beekeeper and ale-wife</p>
<p class="nonindent"><strong>Oliver Becker</strong>. Son of Jakob the baker</p>
<p class="nonindent"><strong>Bertram Unterbaum</strong>. Owes “handservice” as herald to the Herr. Oliver’s rival for Anna Kohlmann</p>
<p class="nonindent"><strong>Anna Kohlmann</strong>. Kohlmann’s daughter</p>
<p class="nonindent"><strong>Geirech Jaeger</strong>. A hunter</p>
<p class="center">BURG HOCHWALD</p>
<p class="nonindent"><strong>Herr Manfred von Hochwald</strong>. Lord of the High Woods. A widower</p>
<p class="nonindent"><strong>Kunigund</strong>. Manfred’s older daughter, fiancée to Eugen</p>
<p class="nonindent"><strong>Irmgard</strong>. Manfred’s younger daughter</p>
<p class="nonindent"><strong>Eugen</strong>. Manfred’s junker (der junge Herr)</p>
<p class="nonindent"><strong>Thierry von Hinterwaldkopf</strong>. One of Manfred’s vassals. A Ritter (knight)</p>
<p class="nonindent"><strong>Max Schweitzer</strong>. Sergeant at arms. Has charge of Manfred’s garrison</p>
<p class="nonindent"><strong>Peter von Rheinhausen</strong>. Manfred’s minnesinger</p>
<p class="nonindent"><strong>Fr. Rudolf</strong>. Manfred’s chaplain</p>
<p class="nonindent"><strong>Everard Steward</strong>. Manfred’s steward, responsible for the sallands and the serfs</p>
<p class="center">THE KRENKEN</p>
<p class="nonindent"><strong>The Herr Gschert</strong>. Steward of the vessel, later called Baron Grosswald</p>
<p class="nonindent"><strong>The Kratzer</strong>. Senior scientist of the charter group</p>
<p class="nonindent"><strong>Shepherd</strong>. <em>Maier</em> of the pilgrims</p>
<p class="nonindent"><strong>Johann (Hans)</strong>. Servant of the talking head</p>
<p class="nonindent"><strong>Gottfried</strong>. Servant of the electronic essence</p>
<p class="nonindent"><strong>Arnold</strong>. Chirurgeon</p>
<p class="nonindent"><strong>Ulf and Heloïse</strong>. Labtechs</p>
<p class="center">OTHERS</p>
<p class="nonindent"><strong>Philip von Falkenstein</strong>. A robber baron</p>
<p class="nonindent"><strong>Malachai ben Shlomo</strong>. A factor for the Seneor family, based in Regensburg</p>
<p class="nonindent"><strong>Tarkhan Hazar ben Bek</strong>. Malachai’s servant</p>
<p class="nonindent"><strong>Einhardt and Rosamund</strong>. An imperial knight and his wife. Holds a fief near Oberhochwald</p>
<p class="nonindent"><strong>A Freiburg fishwife and her son</strong>.</p>
<p class="nonindent"><strong>Archdeacon Willi Jarlsberg</strong>. Onetime classmate of Dietrich’s. Holds Freiburg for the Bishop of Strassburg</p>
<p class="nonindent"><strong>A Savoyard Chirurgeon</strong>.</p>
<p class="nonindent"><strong>William of Ockham</strong>. The <em>venerabilis inceptor</em>. Widely known philosopher, at Kaiser Ludwig’s court</p>
<p class="nonindent"><strong>Imre</strong>. A peddler from Hungary</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780765340351_epub_prf_r1.vue?160b2d40